<template>
  <div class="box">
    <div id="header">
      <div class="header content-continer">
        <p class="logo left">
          <router-link to="/home">
            <img src="../assets/logo1.png" />
          </router-link>
        </p>
        <p
          class="right icon-btn"
          @click="returns"
          style="color: rgba(255,255,255,1);font-weight:400;font-size:14px;margin-right: 30px;"
        >
          <img src="../assets/tui.png" />退出
        </p>
        <p class="right icon-btn">
          <el-dropdown trigger="click">
            <span
              class="el-dropdown-link"
              style="color: rgba(255,255,255,1);font-weight:400;font-size:14px;"
            >
              <img src="../assets/guan.png" style="width: 40px;height: 40px;" />
              管理员
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <router-link to="/hospitalaudit/company-means">公司信息</router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <router-link to="/hospitalaudit/user-menas">权限分配</router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </p>
      </div>
    </div>
    <div class="line"></div>
    <el-menu
      default-active="/hospitalaudit/hostla"
      router
      class="el-menu-demo ta"
      mode="horizontal"
      text-color="#999999"
      style="width:9%;height:100vh;float:left;border-bottom: none ;"
    >
      <el-menu-item index="/hospitalaudit/hostla">医院注册审核</el-menu-item>
      <el-menu-item index="/hospitalaudit/companyaudit">公司注册审核</el-menu-item>
      <el-menu-item index="/hospitalaudit/crcaudit">CRC注册列表</el-menu-item>
    </el-menu>
    <router-view />
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "box",
  data() {
    return {
      imgurl: this.Common.imgurl,
      cnName: "管理员",
      msg: "Welcome to Your Vue.js App"
    };
  },
  mounted() {},
  methods: {
    aa() {
      // alert(1);
    },
    returns() {
      let token = Cookies.get("token");
      console.log(token);
      Cookies.remove("token");
      Cookies.remove("userid");
      console.log(Cookies.get("token"));
      this.$router.replace("/login-company");
    }
  },
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#F5F5F5;");
  },
  //销毁前清除
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  }
};
</script>

<style scoped>
.ta {
  border-bottom: none;
}
.header {
  width: 100%;
  height: 70px;
  background: rgba(54, 114, 191, 1);
  /*border: 2px solid rgba(255, 255, 255, 1);*/
  box-shadow: 0px 1px 21px 0px rgba(202, 202, 202, 0.4);
  line-height: 70px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  width: 100%;
  color: rgba(54, 114, 191, 1);
  background: rgba(238, 242, 246, 1);
  font-size: 14px;
  /*border-radius: 4px;*/
  /*border-bottom: 2px solid rgba(54, 114, 191, 1);*/
}
.left {
  margin-left: 30px;
}
#header img {
  vertical-align: middle;
}
#header img {
  vertical-align: middle;
}

.icon-btn {
  margin-left: 30px;
  cursor: pointer;
}

.icon-btn img {
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 6px;
}
</style>


// WEBPACK FOOTER //
// src/administrators/hospitalaudit.vue